import ViewCourses from "../../shared/components/StudentDashboard/StudentCourses/ViewCourses";

export default function StudentCoursePage () {

    return(
        <ViewCourses/>
    )
}